import { EventEmitterInterface } from 'pf-frontend-common/src/module/event/emitter.interface';

import { BuildingReviewAgentSwitchTemplatePropsInterface } from 'common/module/building-review/agent-switch/template-props.interface';
import { BuidlingReviewAgentSwitchViewStoreOptionsInterface } from 'common/module/building-review/agent-switch/view-store-options.interface';
import { DataStore } from 'common/module/data/store';

export class BuildingReviewAgentSwitchViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: BuildingReviewAgentSwitchTemplatePropsInterface;

  /**
   * Constructor
   */
  public constructor(eventEmitter: EventEmitterInterface) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options?: BuidlingReviewAgentSwitchViewStoreOptionsInterface): void {
    let isSaleCategoryActive = true;
    if (options && options.isSaleCategoryActive !== null) {
      isSaleCategoryActive = options.isSaleCategoryActive;
    }

    this.state = {
      isSaleCategoryActive,
      onClickForRent: this.onClickForRent,
      onClickForSale: this.onClickForSale,
    };
  }

  /**
   * @inheritDoc
   */
  public getState(): BuildingReviewAgentSwitchTemplatePropsInterface {
    return this.state;
  }

  /**
   * clicked for rent
   */
  private onClickForRent = () => {
    this.setSwitch(true);
  };

  /**
   * clicked for sale
   */
  private onClickForSale = () => {
    this.setSwitch(false);
  };

  /**
   * sets switch to a state
   */
  private setSwitch(isSaleCategoryActive: boolean): void {
    this.setState({
      ...this.state,
      isSaleCategoryActive,
    });
  }
}
